import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const patchClientGeneral = async ({ rootGetters, dispatch }, clientGeneral) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchClientGeneralBySid(clientGeneral.clientSid, clientGeneral);
  return response;
};
